'use client';
'use client';
import * as React from "react";
import { getToolbarSrc } from './_node_modules/@prismicio/client/dist/getToolbarSrc.js';
const PrismicToolbar = ({ repositoryName }) => {
  const src = getToolbarSrc(repositoryName);
  React.useEffect(() => {
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.dataset.prismicToolbar = "";
      script.dataset.repositoryName = repositoryName;
      if (typeof process !== "undefined" && process.env.NODE_ENV === "test") {
        script._evaluateScript = false;
      }
      document.body.appendChild(script);
    }
  }, [repositoryName, src]);
  return null;
};
export {
  PrismicToolbar
};
//# sourceMappingURL=PrismicToolbar.js.map
